// frontend/src/store/authStore.js

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      refreshToken: null,
      user: null,
      isLoading: false,
      error: null,

      // Установить токены и пользователя
      setAuth: (accessToken, refreshToken, user) => {
        set({
          token: accessToken,
          refreshToken: refreshToken,
          user: user,
          error: null,
        })
      },

      // Обновить пользователя
      setUser: (user) => set({ user }),

      // Установить ошибку
      setError: (error) => set({ error }),

      // Очистить ошибку
      clearError: () => set({ error: null }),

      // Выход
      logout: () => {
        set({
          token: null,
          refreshToken: null,
          user: null,
          error: null,
        })
      },

      // Установить loading
      setLoading: (isLoading) => set({ isLoading }),

      // Обновить access token
      updateAccessToken: (newToken) => {
        set({ token: newToken })
      },
    }),
    {
      name: 'auth-store',
      partialize: (state) => ({
        token: state.token,
        refreshToken: state.refreshToken,
        user: state.user,
      }),
    }
  )
)
